export default {
  'SLModal.default.okText': 'Selesai',
  'SLModal.default.cacelText': 'Batal',
  'SLModal.info.okText': 'Mengerti'
};